import React from 'react';
import { Modal } from 'react-bootstrap';
import { useLanguage } from '../../contexts/languageContext';
import './PrivacyNoticeModal.scss';

/**
 * Informativa privacy completa, mostrata come modale.
 *
 * Non e' un banner di consenso e non deve diventarlo: il trattamento descritto
 * qui si fonda sul legittimo interesse (antiabuso e contenimento dei costi),
 * non sul consenso. La modale informa, non raccoglie una scelta.
 *
 * Il contenuto vive nelle traduzioni come blocchi HTML, come il resto dei testi
 * lunghi del sito: sono stringhe statiche del bundle, non input utente.
 */

/** Recapito del titolare. Deve essere una casella realmente presidiata. */
export const PRIVACY_CONTACT_EMAIL = 'luca.astolfi88@gmail.com';

/** Sezioni nell'ordine di lettura. Ogni voce ha una chiave `<nome>Title` e `<nome>Body`. */
const SECTIONS = [
  'privacyController',
  'privacyData',
  'privacyPurpose',
  'privacyRecipients',
  'privacyRetention',
  'privacyNotDone',
  'privacyRights',
  'privacyCookies',
  'privacyAi',
] as const;

interface PrivacyNoticeModalProps {
  show: boolean;
  onHide: () => void;
}

const PrivacyNoticeModal: React.FC<PrivacyNoticeModalProps> = ({ show, onHide }) => {
  const { t } = useLanguage();

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      scrollable
      className="privacy-notice"
      backdropClassName="privacy-notice__backdrop"
      aria-labelledby="privacy-notice-title"
    >
      <Modal.Header closeButton>
        <Modal.Title as="h2" id="privacy-notice-title" className="privacy-notice__title">
          {t('privacyTitle')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="privacy-notice__body">
        <p className="privacy-notice__lead">{t('privacyLead')}</p>

        {SECTIONS.map((section) => (
          <section key={section} className="privacy-notice__section">
            <h3 className="privacy-notice__heading">{t(`${section}Title`)}</h3>
            <div dangerouslySetInnerHTML={{ __html: t(`${section}Body`) }} />
          </section>
        ))}

        <p className="privacy-notice__updated">{t('privacyUpdated')}</p>
      </Modal.Body>
    </Modal>
  );
};

export default PrivacyNoticeModal;
